export default {
  statuses: {
    ACTIVE: 0,
    ARCHIVED: 1
  },
  sources: {
    ADMIN: 0,
    COUPON: 1
  },
  sourcesText: {
    0: 'Admin',
    1: 'Coupon',
    2: 'Fixed Price',
    3: 'Split Package'
  }
}



// WEBPACK FOOTER //
// ./src/store/discount/state.js